import { DateTimeStyle } from 'Components/Layout/Grid/types';
import {
  IWithWorksheetInjectedProps,
  WorksheetGridFieldSection,
  WorksheetRecordGrid,
} from 'Components/Worksheets/Core';
import { pipe } from 'Lib/Hooks/Selectors';
import { useSelector } from 'react-redux';
import { createDryMassEntryOptionSelector } from '../..';
import { Field, NumericInput, TextOutput } from '../../../../Core';
import { withInjectedProps } from '../../../../Core/InjectedPropsContext';
import { ListFieldSection, SectionGroup } from '../../../../Layout';
import { WorksheetBalanceFieldSet } from '../../../Core/WorksheetEquipment';
import { getDryMassGridFieldSet } from '../gridFieldSets';

let BsDryMassesSection: React.FC<IWithWorksheetInjectedProps> = ({ createWorksheetSelector }) => {
  const dryMassEntryOption = useSelector(createDryMassEntryOptionSelector(createWorksheetSelector!));

  const showSingleReadingSection = useSelector(
    pipe(
      createWorksheetSelector!('DryingTray.DryMassReadings'),
      (r) => (r?.length ?? 0) <= 1 && dryMassEntryOption === 'Never'
    )
  );

  return (
    <SectionGroup>
      <ListFieldSection>
        <WorksheetBalanceFieldSet name="Equipment.DryMassBalance" />
      </ListFieldSection>
      {showSingleReadingSection ? (
        <ListFieldSection>
          <Field
            input={<NumericInput />}
            name="DryingTray.DryMassReadings.0.DrySoilAndContainerMass"
            // We do not show the dry mass calculated from the Tare + Dry mass, so we need to show its messages on this field
            additionalMessagePaths={['DryingTray.DryMassReadings.0.DrySoilMass']}
          />
          <Field input={<TextOutput />} name="DryingTray.ConstantDrySoilMass" />
        </ListFieldSection>
      ) : (
        <>
          <WorksheetGridFieldSection name="DryingTray.DryMassReadings">
            <WorksheetRecordGrid
              name="DryingTray.DryMassReadings"
              orientation="vertical"
              recordProps={{
                enforceAtLeastOneRecord: true,
                preventRemove: 'all-but-last',
                preventCreate: dryMassEntryOption === 'Never',
                removeConfirm: {
                  confirm: true,
                  confirmTitle: 'Delete Dry Mass Reading',
                  confirmText: 'Are you sure you want to delete the dry mass reading? Data cannot be recovered.',
                  confirmButtonText: 'Delete',
                },
              }}
              fieldSet={getDryMassGridFieldSet(dryMassEntryOption, DateTimeStyle.Combined)}
            />
          </WorksheetGridFieldSection>
          <ListFieldSection>
            <Field input={<TextOutput />} name="DryingTray.ConstantDrySoilMass" />
          </ListFieldSection>
        </>
      )}
    </SectionGroup>
  );
};

BsDryMassesSection = withInjectedProps(BsDryMassesSection);

export { BsDryMassesSection };
export default BsDryMassesSection;
